var angular = require('angular');
//controller for expanded playlist item which shows subjects
module.exports = ['$scope', '$rootScope', 'Confirm', 'PlaylistItemsLoader', 'PlaylistItems', function PlaylistItemsCtrl($scope, $rootScope, Confirm, PlaylistItemsLoader, PlaylistItems) {

    "use strict";

    $scope.playlistItemsLoader = new PlaylistItemsLoader({
        'playlistId': $scope.playlist.id
    }).getAll();

    /**
     * Reorders the subjects in the playlist
     * @param {Array} orderedModels
     */
    $scope.saveOrder = function (subjects) {
        new PlaylistItems({
            'playlistId': $scope.playlist.id,
            'subjects': subjects
        }).$reorder(function () {

        }, function () {
            //something went wrong... reload the items to represent
            //the correct order
            $scope.playlistItemsLoader.getAll();
        });
    };

    /**
     * Removes a single subject from a playlist
     * @param {Object} subject
     * @param {String} message
     */
    $scope.removeFromPlaylist = function (subject, message) {
        Confirm.prompt(function () {
            new PlaylistItems({
                'playlistId': $scope.playlist.id,
                'subjects': [subject]
            }).$remove(function () {
                var index = $scope.playlistItemsLoader.data.indexOf(subject);
                $scope.playlistItemsLoader.data.splice(index, 1);
                $scope.$emit('PLAYLISTITEMS_REMOVEFROMPLAYLIST', $scope.playlist, $scope.playlistItemsLoader.data.length);
            });
        }, message);
    };

    //**** BULK DELETE

    var selected = [];

    //listen to changes in selection in the child scope
    $rootScope.$on('MEDIALIST_SELECT', function (event, selectedModels) {
        selected = selectedModels;
    });

    $scope.$on('playlist.deleteselected', function () {
        //filter out the subjects that are in this playlist from the selections
        var selectedInPlaylist = selected.filter(function (model) {
            return $scope.playlistItemsLoader.data.indexOf(model) > -1;
        });

        new PlaylistItems({
            'playlistId': $scope.playlist.id,
            'subjects': selectedInPlaylist
        }).$remove(function () {
            angular.forEach(selectedInPlaylist, function (subject) {
                var index = $scope.playlistItemsLoader.data.indexOf(subject);
                $scope.playlistItemsLoader.data.splice(index, 1);
            });
            $scope.$emit('PLAYLISTITEMS_REMOVEFROMPLAYLIST', $scope.playlist, $scope.playlistItemsLoader.data.length);
        });
    });

    $scope.$on('PLAYLIST_REORDERED', function () {
        $scope.playlistItemsLoader.getAll();
    });
}];



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/controllers/PlaylistItemsCtrl.js